/**
 * 触发浏览器下载给定的 `Blob`。
 *
 * 处理三个常见踩坑：
 * 1. **未挂到 DOM** —— Firefox / 部分 Chromium 版本要求 `<a>` 在文档树中才会触发下载，
 *    否则 `click()` 表现为无操作或被弹窗拦截，导致用户长时间无反应。
 * 2. **过早 `revokeObjectURL`** —— 如果在浏览器实际开始下载前就 revoke，会出现下载失败、
 *    “保存路径”对话框延迟数秒甚至无声丢弃。需要把 revoke 延后到当前事件循环之后。
 * 3. **被合成手势风险** —— 使用 `style.display = 'none'` + `rel="noopener"` 避免可见跳动，
 *    且不依赖 `target="_blank"`（避免 popup blocker 拦截）。
 *
 * @param blob - 要下载的二进制
 * @param fileName - 建议的文件名（含扩展名）
 */
export function triggerBlobDownload(blob: Blob, fileName: string): void {
  if (typeof document === 'undefined' || typeof URL === 'undefined') return
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.rel = 'noopener'
  a.style.display = 'none'
  document.body.appendChild(a)
  try {
    a.click()
  } finally {
    /**
     * `setTimeout(_, 0)` 让出事件循环：保证浏览器在 revoke 之前已经把当前 click
     * 派发为下载请求；同步 revoke 在 Chrome / Edge 的某些版本会触发“另存为”对话
     * 延迟弹出甚至下载失败。
     */
    globalThis.setTimeout(() => {
      try {
        a.remove()
      } catch {
        /* 节点可能已被外部移除，忽略 */
      }
      try {
        URL.revokeObjectURL(url)
      } catch {
        /* ignore */
      }
    }, 0)
  }
}
